export const materialItemsHeaders = [
  {
    id: 1,
    name: "Sales Number",
    dataKey: "salesNumber",
    class: "salesNumberHeader",
    classNameOne: "m-b-16",
  },
  {
    id: 2,
    name: "Product Name",
    dataKey: "productName",
    class: "productNameHeader",
    classNameOne: "m-b-16",
  },
  {
    id: 3,
    name: "Quantity",
    dataKey: "quantity",
    class: "matquantityHeader",
    classNameOne: "m-b-16",
  },
  {
    id: 4,
    name: "Unit Price",
    dataKey: "price",
    class: "matPriceHeader",
    classNameOne: "m-b-16",
  },
  {
    id: 5,
    name: "Extended Price",
    dataKey: "extendedPrice",
    class: "matextPriceHeader",
    classNameOne: "m-b-16",
  },
  {
    id: 6,
    name: "Sales Tax",
    dataKey: "salesTax",
    class: "matsalesTaxHeader",
    classNameOne: "m-b-16",
  },
  {
    id: 7,
    name: "Checkbox",
  },
  {
    id: 8,
    name: "Total",
    dataKey: "total",
    class: "mattotalHeader",
    classNameOne: "m-b-16",
  },
];

export const laborItemsHeaders = [
  { id: 1, name: "Labor Code", dataKey: "laborCode", className: "laborCodeHeader", classNameOne: "m-b-16" },
  { id: 2, name: "Description", dataKey: "description", className: "descriptionHeader", classNameOne: "m-b-16" },
  { id: 3, name: "Quantity", dataKey: "quantity", className: "quantityHeader", classNameOne: "m-b-16" },
  { id: 4, name: "Unit Price", dataKey: "price", className: "priceHeader", classNameOne: "m-b-16" },
  { id: 5, name: "Extended Price", dataKey: "extendedPrice", className: "extPriceHeader", classNameOne: "m-b-16" },
  { id: 6, name: "Sales Tax", dataKey: "salesTax", className: "salesTaxHeader", classNameOne: "m-b-16" },
  { id: 7, name: "Checkbox", className: "checkboxHeader", sortable: false },
  { id: 8, name: "Total", dataKey: "total", className: "totalHeader", classNameOne: "m-b-16" },
];

export const laborItemsHeadersEditable = [
  { id: 1, name: "Labor Code", dataKey: "laborCode", className: "laborCodeHeader", classNameOne: "m-b-16" },
  { id: 2, name: "Description", dataKey: "description", className: "descriptionHeader", classNameOne: "m-b-16" },
  { id: 3, name: "Quantity", dataKey: "quantity", className: "quantityHeader", classNameOne: "m-b-16" },
  { id: 4, name: "Unit Price", dataKey: "price", className: "priceHeader", classNameOne: "m-b-16" },
  { id: 5, name: "Extended Price", dataKey: "extendedPrice", className: "extPriceHeader", classNameOne: "m-b-16" },
  { id: 6, name: "Sales Tax", dataKey: "salesTax", className: "salesTaxHeader", classNameOne: "m-b-16" },
  { id: 7, name: "Checkbox", className: "checkboxHeader" },
  { id: 8, name: "Total", dataKey: "total", className: "totalHeader", classNameOne: "m-b-16" },
  { id: 9, name: "Edit", className: "editHeader", classNameOne: "m-b-16" },
  { id: 10, name: "Delete", className: "deleteHeader" },
];

export const materialItemsHeadersEditable = [
  {
    id: 1,
    name: "Sales Number",
    dataKey: "salesNumber",
    class: "salesNumberHeader",
    classNameOne: "m-b-16",
  },
  {
    id: 2,
    name: "Product Name",
    dataKey: "productName",
    class: "productNameHeader",
    classNameOne: "m-b-16",
  },
  {
    id: 3,
    name: "Quantity",
    dataKey: "quantity",
    class: "matquantityHeader",
    classNameOne: "m-b-16",
  },
  {
    id: 4,
    name: "Unit Price",
    dataKey: "price",
    class: "matPriceHeader",
    classNameOne: "m-b-16",
  },
  {
    id: 5,
    name: "Extended Price",
    dataKey: "extendedPrice",
    class: "matextPriceHeader",
    classNameOne: "m-b-16",
  },
  {
    id: 6,
    name: "Sales Tax",
    dataKey: "salesTax",
    class: "matsalesTaxHeader",
    classNameOne: "m-b-16",
  },
  {
    id: 7,
    name: "Checkbox",
  },
  {
    id: 8,
    name: "Total",
    dataKey: "total",
    class: "mattotalHeader",
    classNameOne: "m-b-16",
  },
  {
    id: 9,
    name: "Edit",
    class: "editHeader",
    classNameOne: "m-b-16",
  },
  {
    id: 10,
    name: "Delete",
    class: "deleteHeader",
  },
];

export const storeValue = (storeNumber, storeName, phoneNumber) => {
  if (storeNumber && storeName && phoneNumber) {
    return `${storeNumber} - ${storeName} - ${phoneNumber}`;
  } else if (storeNumber && storeName) {
    return `${storeNumber} - ${storeName}`;
  } else if (storeName && phoneNumber) {
    return `${storeName} - ${phoneNumber}`;
  } else if (storeNumber && phoneNumber) {
    return `${storeNumber} - ${phoneNumber}`;
  } else if (storeNumber && !storeName && !phoneNumber) {
    return storeNumber;
  } else if (!storeNumber && storeName && !phoneNumber) {
    return storeName;
  } else if (!storeNumber && !storeName && phoneNumber) {
    return phoneNumber;
  } else {
    return "N/A";
  }
};

export const accountValue = (accNum, accName) => {
  if (accNum && accName) {
    return `${accNum} - ${accName}`;
  } else if (accNum && (!accName || accName == "null")) {
    return accNum;
  } else if (accName && (!accNum || accNum == "null")) {
    return accName;
  } else {
    return "";
  }
};

export const address = (street, city, state, zip) => {
  if (street && city && zip && state) {
    return `${street}, ${city}, ${state} - ${zip}`;
  } else if (street && city && state) {
    return `${street}, ${city}, ${state}`;
  } else if (state && city && zip) {
    return `${city}, ${state} - ${zip}`;
  } else if (street && city && zip && !state) {
    return `${street}, ${city} - ${zip}`;
  } else if (street && zip) {
    return `${street} - ${zip}`;
  } else if (street && !city && !zip) {
    return street;
  } else if (!street && city && !zip) {
    return city;
  } else if (!street && !city && zip) {
    return zip;
  } else {
    return "";
  }
};

export const accountSummary = (acc, address, contact) => {
  if (acc && address && contact) {
    return `${acc}, ${address}, ${contact}`;
  } else if (acc && address) {
    return `${acc}, ${address}`;
  } else if (address && contact) {
    return `${address}, ${contact}`;
  } else if (acc && contact) {
    return `${acc}, ${contact}`;
  } else if (acc && !address && !contact) {
    return acc;
  } else if (!acc && address && !contact) {
    return address;
  } else if (!acc && !address && contact) {
    return contact;
  } else {
    return "N/A";
  }
};

export const contactPhone = (contact, phone) => {
  if (contact && phone) {
    return `${contact} - ${phone}`;
  } else if (contact && (!phone || phone == "null")) {
    return contact;
  } else if (phone && (!contact || contact == "null")) {
    return phone;
  } else {
    return "";
  }
};

const decimalCount = (num) => {
  const numStr = String(num);
  if (numStr.includes(".")) {
    return numStr.split(".")[1].length;
  }
  return 0;
};

export const taxFormat = (tax) => {
  var decimalLength = decimalCount(tax);
  if (decimalLength <= 2) {
    return parseFloat(tax).toFixed(2) + "%";
  } else if (decimalLength == 3) {
    return parseFloat(tax).toFixed(3) + "%";
  } else if (decimalLength >= 4) {
    return parseFloat(tax).toFixed(4) + "%";
  } else if (decimalLength == 0) {
    return parseFloat(tax).toFixed(2) + "%";
  }
};

export const nationalParent = (parentNum, parentName, execNumber, execName) => {
  if (parentNum && parentName && execNumber && execName) {
    return `${parentNum} - ${parentName} , ${execNumber} - ${execName}`;
  } else if (parentNum && parentName && !execNumber && !execName) {
    return `${parentNum} - ${parentName}`;
  } else if (!parentNum && !parentName && execNumber && execName) {
    return `${execNumber} - ${execName}`;
  } else if (parentNum && !parentName && execNumber && execName) {
    return `${parentNum} , ${execNumber} - ${execName}`;
  } else if (!parentNum && parentName && execNumber && execName) {
    return `${parentName} , ${execNumber} - ${execName}`;
  } else if (parentNum && parentName && !execNumber && execName) {
    return `${parentNum} - ${parentName} , ${execName}`;
  } else if (parentNum && parentName && execNumber && !execName) {
    return `${parentNum} - ${parentName} , ${execNumber}`;
  } else if (parentNum && !parentName && !execNumber && !execName) {
    return parentNum;
  } else if (!parentNum && parentName && !execNumber && !execName) {
    return parentName;
  } else if (!parentNum && !parentName && execNumber && !execName) {
    return execNumber;
  } else if (!parentNum && !parentName && !execNumber && execName) {
    return execName;
  } else {
    return "N/A";
  }
};

export const quoteSearchColumns = [
  {
    id: 1,
    name: "Quote Name",
    dataKey: "quoteName",
    sortable: true,
  },
  {
    id: 2,
    name: "Account #",
    dataKey: "accountNumber",
    sortable: true,
  },
  {
    id: 3,
    name: "Account Name",
    dataKey: "accountName",
    sortable: true,
  },
  {
    id: 4,
    name: "PunchOut",
    dataKey: "punchout",
    sortable: false,
  },
  {
    id: 5,
    name: "Store #",
    dataKey: "storeNumber",
    sortable: true,
  },
  {
    id: 6,
    name: "Updated Date",
    dataKey: "updatedTimeStamp",
    sortable: true,
  },
];

export const filterColumns = [
  "quoteId",
  "quoteName",
  "accountNumber",
  "accountName",
  "storeNumber",
  "updatedTimeStamp",
];

export const quoteLaborConfirmationColumns = [
  {
    id: 1,
    name: "Labor Code",
    dataKey: "laborCode",
    class: "laborHeader",
    keyName: "Labor Code",
    valueName: "laborCode",
    classNameOne: "m-b-16",
    sortable: false,
  },
  {
    id: 2,
    name: "Description",
    dataKey: "description",
    class: "desHeader",
    keyName: "Description",
    valueName: "description",
    classNameOne: "m-b-16",
    sortable: false,
  },
  {
    id: 3,
    name: "Old Price",
    dataKey: "oldPrice",
    class: "laborOldAmt",
    keyName: "Old Price",
    valueName: "oldPrice",
    classNameOne: "m-b-16",
    sortable: false,
  },
  {
    id: 4,
    name: "Updated Price",
    dataKey: "price",
    class: "laborAmt",
    keyName: "Updated Price",
    valueName: "price",
    classNameOne: "m-b-16",
    sortable: false,
  },
];

export const quoteProductConfirmationColumns = [
  {
    id: 1,
    name: "Sales Number",
    dataKey: "salesNumber",
    class: "salesNum",
    keyName: "Sales Number",
    valueName: "salesNumber",
    classNameOne: "m-b-16",
    sortable: false,
  },
  {
    id: 2,
    name: "Product Name",
    dataKey: "productName",
    class: "prodNameHeader",
    keyName: "Product Name",
    valueName: "productName",
    classNameOne: "m-b-16",
    sortable: false,
  },
  {
    id: 3,
    name: "Old Price",
    dataKey: "oldPrice",
    class: "prodOldAmt",
    keyName: "Old Price",
    valueName: "oldPrice",
    classNameOne: "m-b-16",
    sortable: false,
  },
  {
    id: 4,
    name: "Updated Price",
    dataKey: "price",
    class: "prodAmt",
    keyName: "Updated Price",
    valueName: "price",
    classNameOne: "m-b-16",
    sortable: false,
  },
];

export const filterConfirmationColumns = ["quoteId", "quoteName", "salesNumber", "productName", "oldPrice", "price"];
export const filterLaborColumns = ["quoteId", "quoteName", "laborCode", "description", "oldPrice", "price"];

export const currencyValue = (value) => {
  value = value?.toString().replace("$", "");
  if (!value || isNaN(value) || value === null) return "";
  // eslint-disable-next-line
  value = value.toString().replace(/\,/g, "");
  var formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
  });
  return formatter.format(value);
};

export const getUniqueQuoteData = (data) => {
  let temp1 = JSON.parse(JSON.stringify(data.productDtoList ?? []));
  let temp2 = JSON.parse(JSON.stringify(data.laborCodesList ?? []));
  const filteredSalesArr = temp1.filter((ele, index) => ele.salesNumber);
  const res1 = Object.values(
    filteredSalesArr.reduce((acc, prod) => {
      if (acc[prod.salesNumber]) {
        if (acc[prod.salesNumber].price !== prod.price) {
          acc[prod.salesNumber].isPriceVaries = true;
        }
        acc[prod.salesNumber] = acc[prod.salesNumber];
      } else {
        acc[prod.salesNumber] = { ...prod };
      }
      if (acc[prod.salesNumber].price < prod.price) {
        prod.isPriceVaries = true;
        acc[prod.salesNumber] = { ...prod };
      }

      return acc;
    }, {}),
  );

  const filteredNameArr = temp1.filter((ele, index) => !ele.salesNumber);
  const res2 = Object.values(
    filteredNameArr.reduce((acc, prod) => {
      if (acc[prod.productName]) {
        if (acc[prod.productName].price !== prod.price) {
          acc[prod.productName].isPriceVaries = true;
        }
        acc[prod.productName] = acc[prod.productName];
      } else {
        acc[prod.productName] = { ...prod };
      }
      if (acc[prod.productName].price < prod.price) {
        prod.isPriceVaries = true;
        acc[prod.productName] = { ...prod };
      }
      return acc;
    }, {}),
  );
  const prodRes = [...res1, ...res2];

  const filteredLaborArr = temp2.filter((ele, index) => ele.laborCode);
  const laborRes = Object.values(
    filteredLaborArr.reduce((acc, labor) => {
      if (acc[labor.laborCode]) {
        if (acc[labor.laborCode].price !== labor.price) {
          acc[labor.laborCode].isPriceVaries = true;
        }
        acc[labor.laborCode] = acc[labor.laborCode];
      } else {
        acc[labor.laborCode] = { ...labor };
      }
      if (acc[labor.laborCode].price < labor.price) {
        labor.isPriceVaries = true;
        acc[labor.laborCode] = { ...labor };
      }
      return acc;
    }, {}),
  );
  return { uniqueLaborCodes: laborRes, uniqueProducts: prodRes };
};

/**
 * Utility function to centralize line item total calculations. Values are converted to floats.
 * Their values are converted to cents and rounded. All calcuations are with cents and rounded
 * to the nearest cent. Values are finally converted back to dollars before being returned
 */
export const calcuateLineItemTotal = ({ price, quantity, taxRate }) => {
  const priceInCents = Math.round(parseFloat(price) * 100);
  // quantities are rounded to two decimal places
  const normalizedQuantity = Math.round(parseFloat(quantity) * 100) / 100;
  const extendedPriceInCents = Math.round(priceInCents * normalizedQuantity);
  const normalizedTaxRate = parseFloat(taxRate) / 100;
  const salesTaxInCents = Math.round(extendedPriceInCents * normalizedTaxRate);
  const totalInCents = extendedPriceInCents + salesTaxInCents;

  return {
    price: priceInCents / 100,
    quantity: normalizedQuantity,
    extendedPrice: extendedPriceInCents / 100,
    salesTax: salesTaxInCents / 100,
    total: totalInCents / 100,
  };
};
